module.exports = __webpack_public_path__ + "static/GreycliffCF-DemiBold-d591692147d6deab77177935eaa3627c.otf";